<div id="checkbox">
  <fieldset *ngFor="let checkbox of checkboxData; let i = index;" (click)="toggleCheckbox(i, checkbox.cdTpServico);" [class.active]="checkbox.checked">
    <span class="icn-check"></span>

    {{ checkbox.dsTpServico }}
  </fieldset>
</div>
